import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase.config";
import { useState } from "react";

const getErrorMessage = (code) => {
  switch (code) {
    case "auth/user-not-found":
      return "No user found with this email.";
    case "auth/wrong-password":
      return "Incorrect password. Please try again.";
    case "auth/invalid-email":
      return "Email format is invalid.";
    case "auth/too-many-requests":
      return "Too many login attempts. Please try again later.";
    case "auth/invalid-credential":
      return "Invalid email or password.";
    default:
      return "Something went wrong. Please try again.";
  }
};

const useLogin = () => {
  const [loading, setLoading] = useState(false);

  const login = async (values, onSuccess, onError) => {
    setLoading(true);
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        values.email,
        values.password
      );

      const user = userCredential.user;

      if (!user.emailVerified) {
        throw new Error("Please verify your email before logging in.");
      }

      if (onSuccess) onSuccess(user);
    } catch (err) {
      const friendlyMessage = err.code
        ? getErrorMessage(err.code)
        : err.message;
      if (onError) onError({ message: friendlyMessage });
    } finally {
      setLoading(false);
    }
  };

  return { login, loading };
};

export default useLogin;
